import { localStore } from '@guuru/storage-web';

const LanguageStore = {
  save: (language?: string) => (
    localStore.setConfig('SYSTEM_LOCALE', language)
  ),

  get: () => (
    localStore.getConfig('SYSTEM_LOCALE')
  ),
};

export default LanguageStore;
